import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const VideoCarousel = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [modalVideo, setModalVideo] = useState(null);

  const videos = [
    { id: 1, type: "youtube", embedUrl: "https://www.youtube.com/embed/rBPOtsl1pkE", title: "Music Video 1" },
    { id: 2, type: "youtube", embedUrl: "https://www.youtube.com/embed/qwp86qhYubs", title: "Music Video 2" },
    // { id: 3, type: "instagram", embedUrl: "https://www.instagram.com/reel/C7QoFbay1xw", title: "Instagram Reel" },
    { id: 4, type: "youtube", embedUrl: "https://www.youtube.com/embed/mTHA3b-RHnw", title: "Music Video 3" },

  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
    mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
  };

  const renderVideo = (video) => {
    if (video.type === "youtube") {
      return (
        <iframe
          src={`${video.embedUrl}?autoplay=0&mute=0&controls=0&modestbranding=1&rel=0`}
          title={video.title}
          className="w-full h-full"
          allowFullScreen
        />
      );
    }
    if (video.type === "instagram") {
      return (
        <div
          className="w-full h-full bg-gray-800 flex items-center justify-center cursor-pointer text-white font-bold"
          onClick={() => setModalVideo(video.embedUrl)}
        >
          Play Instagram Reel
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-black text-white pt-[64px] md:pt-[128px] pb-[32px] font-inter">
      <div className="text-center mb-[32px]">
       <h2 className="text-2xl md:text-5xl font-normal text-white font-inter">
          WATCH OUR WORK
        </h2>
        <p className="text-white text-sm md:text-lg max-w-2xl mx-auto font-inter font-normal mt-2 md:mt-4 mb-7 md:mb-[62px] md:max-w-[481px]">
          Highlights from music videos, reels, and visualisers we’ve produced.
        </p>
      </div>

      <div className="max-w-7xl mx-auto relative">
        {isMobile ? (
          <div className="space-y-6">
            {videos.map((video) => (
              <div key={video.id} className="aspect-video bg-gray-800 rounded-lg overflow-hidden">
                {renderVideo(video)}
              </div>
            ))}
          </div>
        ) : (
          <Carousel responsive={responsive} infinite autoPlay autoPlaySpeed={5000} arrows>
            {videos.map((video) => (
              <div key={video.id} className="aspect-video bg-black rounded-lg overflow-hidden px-2">
                {renderVideo(video)}
              </div>
            ))}
          </Carousel>
        )}
      </div>

      {/* Modal for Instagram */}
      {modalVideo && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4"
    onClick={() => setModalVideo(null)}
  >
    <div
      className="bg-black rounded-lg overflow-hidden"
      style={{
        width: window.innerWidth >= 768 ? 'auto' : '90vw',  // desktop vs mobile width
        height: window.innerWidth >= 768 ? '80vh' : '80vh', // desktop taller, mobile shorter
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <iframe
        src={`${modalVideo}/embed?autoplay=1`}
        title="Instagram Reel"
        className="w-full h-full"
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
        allowFullScreen
      />
    </div>
  </div>
)}


    </div>
  );
};

export default VideoCarousel;
